export default __webpack_public_path__ + "68e623f0c5fbb7900714fa20d9aa8874.jpg";